import { doc, getFirestore, setDoc } from "@firebase/firestore";
import { signInWithPopup, getAuth, GoogleAuthProvider, provider } from "fbase";
import React from "react";

const Auth = () => {
  const auth = getAuth();
  const referrerId = window.location.href.slice(
    window.location.href.indexOf("referrer=") + 9
  );
  const signInWithGoogle = async () => {
    signInWithPopup(auth, provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        const user = result.user;
        const userUID = result.user.uid;
        console.log(user, token);
        console.log(user.metadata.createdAt, user.metadata.lastLoginAt);
        if (
          referrerId &&
          user.metadata.lastLoginAt - user.metadata.createdAt < 1000
        ) {
          const db = getFirestore();
          const obj = {};
          obj[userUID] = true;
          setDoc(doc(db, referrerId, "referrer"), obj, { merge: true });
        }
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
        console.log(errorCode, errorMessage, email, credential);
      });
  };
  const onClick = () => {
    signInWithGoogle();
    console.log("click");
  };
  return (
    <div>
      <div>
        <button onClick={onClick}>Continue with Google Login</button>
      </div>
    </div>
  );
};
export default Auth;
